import { HttpClient } from '../HttpClient';
/**
 * * Get All job Request by status
 */

export const GetAllJobRequestByStatus = async (status) => {
  try {
    const { data } = await HttpClient.get(`api/jobrequisitions?status=${status}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
